
export const resetAlerts = (fetch) => ({
    payload: {
        dataset: 'alerts',
        action: 'reset',
        route: '',
        data: {},
    },
    fetch,
});

export default resetAlerts;
